import React, { Component } from 'react'
import { mastervalues_api, apiInstance } from "../actions/http"

class MasterValue extends Component {
    
    state = {
        fetching: false,
        data: null,
        error: false
    };

    componentDidMount(){
        this.getData();
    }

    async getData(){
        this.setState({fetching: true})
        try {
            let res = await apiInstance({
                url: mastervalues_api + this.props.id + "/",
                method: "GET"
            })
            this.setState({fetching: false, data: res.data})
        } catch(err){
            this.setState({fetching: false})
        }
    } 

    render() {
        let { Component,  compProps, Loader}  = this.props;
        let {fetching, error, data} = this.state;
        if (error) return null;
        if(fetching){
            return (
                Loader ?
                <Loader /> : null
            )
        }
        if(data){
            return <Component {...data} {...compProps} />
        }
        return null;
    }
}

export const MasterHolder = ({value}) => (
    <span>{value}</span>
)

export const MasterLoad = () => (
    <span style={{visibility: `hidden`}}>##########</span>
)

export const MasterGet = ({id, compProps={}}) => (
    <MasterValue Component={MasterHolder} Loader={MasterLoad} compProps={compProps} id={id} />
)

export default MasterValue;